"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const useQueuer = require("./useQueuer.cjs");
function useQueuedState(fn, options = {}, selector) {
  const queue = useQueuer.useQueuer(fn, options, selector);
  return [queue.state.items, queue.addItem, queue];
}
exports.useQueuedState = useQueuedState;
//# sourceMappingURL=useQueuedState.cjs.map
